import _ from 'lodash';
import Note from '../Note';
import randomizeStartingNote from '../lib/randomizeStartingNote';

const nextOptions = [
  [0, 2, -1, 0],
  [0, null, 1, null],
  [0, null, 1, 2],
  [0, 1, 2, 4, 3],
  [0, -3, -2, -1, 0],
  [0, 1, 0, -1, -2],
  [0, 4, null, 3, 5],
  [0, 2, 1, -4, -3],
  [0, 1, 2, -3, -1, 0]
]

export default function manualPatterns(programmer, instrument) {
  const lastPlayed = _.last(instrument.history);
  const startingNote = randomizeStartingNote(lastPlayed && lastPlayed.noteIndex, instrument, programmer);
  const newNoteIndex = startingNote.noteIndex;

  const optionIsPossible = segment => _.every(segment, o => (
    _.isNull(o) || typeof instrument.notes[newNoteIndex + o] !== 'undefined'
  ));

  const options = nextOptions.filter(optionIsPossible);

  return _.sample(options).map( d => new Note( newNoteIndex + d, instrument))

  // return _.sample().map(intervalGenerator('4n', (noteIndex, time) => {
  //   let newIndex = noteIndex + startingNoteIndex;
  //   const velocity = .5 + (Math.random() * .35);

  //   return noteIndex !== null
  //     ? newNoteFromIndex(notes, newIndex, { time, velocity })
  //     : null;
  // }))
}



// WEBPACK FOOTER //
// ./src/patternGenerators/manual.js